import {
  isMongoObjectId,
  registerMockRestEndpoints,
} from "@redotech/rpc-mock/mock-rest";
import {
  createMockUserData,
  mockOnboardingData,
  mockTeamData,
  mockUserData,
} from "./mock-rest-data";

export function registerMerchantMockRestEndpoints(): void {
  registerMockRestEndpoints([
    { pattern: "/team", data: mockTeamData },
    { pattern: "/user", data: mockUserData },
    {
      pattern: "/user/:userId",
      paramValidators: { userId: isMongoObjectId },
      response: ({ params }) => createMockUserData({ _id: params.userId }),
    },
    { pattern: "/user", method: "PUT", data: {} },
    {
      pattern: "/user/:userId/notifications",
      method: "PUT",
      paramValidators: { userId: isMongoObjectId },
      data: {},
    },
    { pattern: "/onboarding", data: mockOnboardingData },
  ]);
}
